var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 11C11.6362 11 10.0701 9.72523 9.62602 8H2.5V6H9.62602C10.0701 4.27477 11.6362 3 13.5 3C15.7091 3 17.5 4.79086 17.5 7C17.5 9.20914 15.7091 11 13.5 11ZM19.5 6H22.5V8H19.5V6ZM8.5 21C6.63616 21 5.07006 19.7252 4.62602 18H2.5V16H4.62602C5.07006 14.2748 6.63616 13 8.5 13C10.7091 13 12.5 14.7909 12.5 17C12.5 19.2091 10.7091 21 8.5 21ZM14.5 18H22.5V16H14.5V18ZM10.5 17C10.5 18.1046 9.60457 19 8.5 19C7.39543 19 6.5 18.1046 6.5 17C6.5 15.8954 7.39543 15 8.5 15C9.60457 15 10.5 15.8954 10.5 17ZM15.5 7C15.5 8.10457 14.6046 9 13.5 9C12.3954 9 11.5 8.10457 11.5 7C11.5 5.89543 12.3954 5 13.5 5C14.6046 5 15.5 5.89543 15.5 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.52ca8633.svg";
export { ForwardRef as ReactComponent };